module.exports = __webpack_public_path__ + "static/media/ui-elements-buttons-right-menu-off.37e9f2ab.svg";